import { CircleCheck, TriangleAlert } from "lucide-react";
import { Button } from "@renewmap/ui/button";
import { useState, useMemo } from "react";
import { useSnapshot } from "valtio";
import { publishManager } from "./publish-manager";

export const PublishButton = () => {
  const [publishing, setPublishing] = useState<boolean>(false);
  const [published, setPublished] = useState<boolean>(false);
  const { types, publishIds } = useSnapshot(publishManager.publishState);

  const { selectedCount, excludedCount } = useMemo(() => {
    const allEntries = Object.values(types).flatMap((t) => t.entries);
    const selectedCount = allEntries.filter((e) => publishIds.has(e.id)).length;
    return { selectedCount, excludedCount: allEntries.length - selectedCount };
  }, [types, publishIds]);

  const publish = () => {
    setPublishing(true);
    publishManager.publish().then((published) => {
      setPublishing(false);
      setPublished(published);
    });
  };

  const rec = (n: number) => `${n} record${n === 1 ? "" : "s"}`;

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-500">
        {rec(selectedCount)} to be published
        {excludedCount > 0 && `, ${rec(excludedCount)} excluded`}
      </span>
      <Button
        disabled={publishing || selectedCount === 0}
        className="flex gap-2 bg-amber-500 px-3 text-black hover:bg-amber-600 disabled:bg-gray-400"
        onClick={publish}
      >
        {published ? <CircleCheck /> : <TriangleAlert />}{" "}
        {published ? "Successfully Published" : "Publish to Production"}
      </Button>
    </div>
  );
};
